// import createHistory from 'history/createBrowserHistory';
console.log("wat???");
// export default createHistory();
export default {};